/* eslint-disable no-unused-vars */
import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { WAREHOUSES_LIST as DEFAULT_WAREHOUSES_LIST } from '../lib/constants';

const QROrderGeneratorPage = ({
  selectedQrRoom = '',
  setSelectedQrRoom = () => {},
  WAREHOUSES_LIST = DEFAULT_WAREHOUSES_LIST,
  handlePrintSticker
}) => {
  const warehouses = WAREHOUSES_LIST || DEFAULT_WAREHOUSES_LIST;
  const filteredWarehouses = warehouses.filter(w => {
    const exclude = [
      "คลังใหญ่ (คลังพัสดุ)",
      "คลังย่อย (คลังห้องฟัน)",
      "ห้องเก็บของ",
      "ห้องคลีนิก",
      "   - ห้อง sterile",
      "   - กำลัง sterile",
      "   - ห้องล้างเครื่องมือ"
    ];
    return !exclude.includes(w.name);
  });

  const generatedUrl = selectedQrRoom && typeof window !== 'undefined'
    ? `${window.location.origin}/?room=${encodeURIComponent(selectedQrRoom)}`
    : '';

  const onPrint = () => {
    if (handlePrintSticker) {
      handlePrintSticker(selectedQrRoom);
      return;
    }
    const canvas = document.getElementById('order-qr-canvas');
    if (!canvas) return;
    const qrDataUrl = canvas.toDataURL('image/png');
    const printWindow = window.open('', '_blank');
    if (!printWindow) return;
    printWindow.document.write(`
      <html>
        <head>
          <title>QR Code - ${selectedQrRoom.trim()}</title>
          <style>
            body {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              height: 100vh;
              margin: 0;
              font-family: 'Segoe UI', 'Noto Sans Thai', sans-serif;
              background-color: #ffffff;
              color: #333333;
            }
            .container {
              border: 3px solid #333333;
              border-radius: 24px;
              padding: 40px;
              text-align: center;
              box-shadow: 0 10px 30px rgba(0,0,0,0.1);
              max-width: 400px;
            }
            img {
              width: 260px;
              height: 260px;
              margin-bottom: 20px;
            }
            h1 {
              font-size: 26px;
              margin: 0 0 10px 0;
              font-weight: 700;
            }
            p {
              font-size: 16px;
              color: #666;
              margin: 0;
            }
          </style>
        </head>
        <body>
          <div class="container">
            <img src="${qrDataUrl}" alt="QR Code" />
            <h1>🛒 สแกนสั่งพัสดุ / เครื่องมือ</h1>
            <p>${selectedQrRoom.trim()}</p>
          </div>
          <script>
            window.onload = function() {
              window.print();
              setTimeout(function() { window.close(); }, 500);
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  return (
    <div style={{
      background: 'rgba(255, 255, 255, 0.05)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      padding: '30px',
      borderRadius: '24px',
      boxShadow: '0 20px 50px rgba(0, 0, 0, 0.4)',
      color: '#ffffff',
      maxWidth: '680px',
      margin: '0 auto',
      fontFamily: "'Segoe UI', 'Noto Sans Thai', sans-serif"
    }}>
      <h2 style={{
        textAlign: 'center',
        color: '#ffffff',
        marginBottom: '30px',
        fontWeight: '700',
        textShadow: '0 2px 10px rgba(0,0,0,0.3)',
        fontSize: '1.8em'
      }}>
        🖼️ สร้าง QR Code สั่งพัสดุรายห้อง
      </h2>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <label style={{ fontWeight: 'bold', color: 'rgba(255, 255, 255, 0.9)' }}>เลือกคลีนิก/ห้อง *</label>
          <select
            value={selectedQrRoom}
            onChange={(e) => setSelectedQrRoom(e.target.value)}
            style={{
              padding: '12px',
              borderRadius: '8px',
              border: '1px solid rgba(255, 255, 255, 0.15)',
              background: 'rgba(255, 255, 255, 0.08)',
              color: '#ffffff',
              fontSize: '1em',
              outline: 'none',
              cursor: 'pointer'
            }}
          >
            <option value="" style={{ background: '#1a0c30', color: '#fff' }}>-- กรุณาเลือกคลีนิก/ห้อง --</option>
            {filteredWarehouses.map(w => (
              <option key={w.name} value={w.name} style={{ background: '#1a0c30', color: '#fff' }}>
                {w.name.trim()}
              </option>
            ))}
          </select>
        </div>

        {selectedQrRoom && (
          <div style={{
            background: 'rgba(255, 255, 255, 0.03)',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            padding: '24px',
            borderRadius: '16px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '20px',
            textAlign: 'center'
          }}>
            <div style={{
              background: '#ffffff',
              padding: '16px',
              borderRadius: '16px',
              boxShadow: '0 10px 25px rgba(0,0,0,0.3)',
              display: 'inline-block'
            }}>
              <QRCodeCanvas
                id="order-qr-canvas"
                value={generatedUrl}
                size={220}
                level="H"
                includeMargin={true}
              />
            </div>

            <div style={{ width: '100%' }}>
              <h4 style={{ margin: '0 0 8px 0', color: '#3498db', fontSize: '1.1em', fontWeight: '700' }}>
                ลิ้งก์สำหรับห้องสั่งของ:
              </h4>
              <div style={{
                padding: '10px 14px',
                background: 'rgba(0,0,0,0.2)',
                border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: '8px',
                color: '#1abc9c',
                wordBreak: 'break-all',
                fontSize: '0.9em',
                fontFamily: 'monospace'
              }}>
                {generatedUrl}
              </div>
            </div>

            <button
              type="button"
              onClick={onPrint}
              style={{
                padding: '12px 28px',
                background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '10px',
                cursor: 'pointer',
                fontSize: '1em',
                fontWeight: 'bold',
                boxShadow: '0 6px 15px rgba(52, 152, 219, 0.25)',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => { e.target.style.boxShadow = '0 10px 25px rgba(52, 152, 219, 0.4)'; e.target.style.transform = 'translateY(-2px)'; }}
              onMouseLeave={(e) => { e.target.style.boxShadow = '0 6px 15px rgba(52, 152, 219, 0.25)'; e.target.style.transform = 'translateY(0)'; }}
            >
              🖨️ พิมพ์ป้าย QR Code
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default QROrderGeneratorPage;
